import { SmallPicture } from "../../../../src/components/SmallPicture";
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';
export default {
  SmallPicture,
  getImage,
  GatsbyImage,
  React
};